
import React from "react";
import { Header } from "semantic-ui-react";
import { WidgetProps, } from "@rjsf/core";
import { getUiOptions } from "../../../../utils/getUiOptions";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";


export const HeaderWidget: React.FC<WidgetProps> = ({
  label,
  schema,
  uiSchema = {},
  ...props
}) => {
  const { t } = useSchemaTranslation();

  const uiOptions = getUiOptions(uiSchema as any);
  const semanticProps = (uiOptions?.semantic || {}) as any;
  const title = label || schema.title || (props as any).name;

  return (
    <Header
      className="sui-header-widget"
      content={t(title)}
      as={semanticProps.as}
      size={semanticProps.size}
      dividing={semanticProps.dividing}
    />
  );
};

export default HeaderWidget;
